import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgManyKeys = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M3.5 15.5V6.505m0 6.995h2m-2-2h3m9-8h-9m7.5 0v-2m-2.5 2v-3m1 12L5.623 5.623m5.327 5.327L12.5 9.5m-3 0 2-2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={3.5} cy={3.5} r={3} stroke="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgManyKeys);
export default ForwardRef;
